import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import React__default, { forwardRef, useState } from 'react';
import { InputSize } from './Input.types.js';
import { AntStyles, StyledInput, StyledSearch, StyledTextArea, AutoCompleteDropdown, StyledAutoComplete } from './Input.styles.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';
import Button from '../Button/Button.js';
import { ButtonType } from '../Button/Button.types.js';
import { SearchOutline16 } from '../../icons/16/index.js';
import { SearchOutline24 } from '../../icons/24/index.js';

var cleanInputProps = function cleanInputProps(props) {
  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return cleanProps(props, ['validateStatus', 'hasFeedback', 'dataSource', 'dropdownMatchSelectWidth', 'buttonLabel'].concat(_toConsumableArray(extraProps)));
};

var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className;
  var themeName = useDesignSystemThemeName();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(StyledInput, _extends({}, cleanInputProps(props), {
    ref: ref,
    className: "".concat(className || '', " ").concat(themeName)
  })));
});
Input.displayName = 'Input';
var SearchInput = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      className = props.className,
      onSearch = props.onSearch,
      _onChange = props.onChange,
      size = props.size,
      buttonLabel = props.buttonLabel,
      startValue = props.value;
  var themeName = useDesignSystemThemeName();

  var _useState = useState(startValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(StyledSearch, _extends({}, cleanInputProps(props, ['onChange']), {
    ref: ref,
    disabled: disabled,
    onChange: function onChange(event) {
      setValue(event.target.value);

      if (_onChange) {
        _onChange(event);
      }
    },
    className: "".concat(className || '', " ").concat(themeName),
    addonAfter: /*#__PURE__*/React__default.createElement(Button, {
      className: "search-input-btn",
      onClick: function onClick(event) {
        if (onSearch) {
          onSearch(value, event);
        }
      },
      "aria-label": buttonLabel,
      type: ButtonType.PRIMARY,
      size: size,
      icon: size === InputSize.SMALL ? /*#__PURE__*/React__default.createElement(SearchOutline16, null) : /*#__PURE__*/React__default.createElement(SearchOutline24, null)
    }),
    allowClear: true
  })));
});
SearchInput.displayName = 'SearchInput';
var TextAreaInput = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className;
  var themeName = useDesignSystemThemeName();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(StyledTextArea, _extends({}, cleanInputProps(props), {
    ref: ref,
    className: "".concat(className || '', " ").concat(themeName)
  })));
});
TextAreaInput.displayName = 'TextAreaInput';
var AutoComplete = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var themeName = useDesignSystemThemeName();

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var onFilter = function onFilter(data, val) {
    var filtered = data.filter(function (obj) {
      return obj.value.toString().toLowerCase().includes(val.toLowerCase());
    });
    setOptions(filtered);
  };

  var className = props.className,
      dataSource = props.dataSource,
      dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
      buttonLabel = props.buttonLabel,
      disabled = props.disabled;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(AutoCompleteDropdown, null), /*#__PURE__*/React__default.createElement(StyledAutoComplete, {
    className: "".concat(className || '', " ").concat(themeName),
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    options: options,
    onSearch: function onSearch(val) {
      return onFilter(dataSource, val);
    },
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(SearchInput, _extends({}, cleanInputProps(props), {
    buttonLabel: buttonLabel,
    ref: ref,
    enterButton: true,
    disabled: disabled
  }))));
});
AutoComplete.displayName = 'AutoComplete';
Input.defaultProps = {
  'data-test-id': 'Input'
};
SearchInput.defaultProps = {
  'data-test-id': 'Search',
  onSearch: function onSearch() {}
};
TextAreaInput.defaultProps = {
  'data-test-id': 'text-area-input'
};
AutoComplete.defaultProps = {
  'data-test-id': 'autocomplete-input'
};

export { AutoComplete, Input, SearchInput, TextAreaInput, Input as default };
//# sourceMappingURL=Input.js.map
